<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Changer de réseau</div>
</div>

<div class="col-12 w-100">
    <div><span class="bold-text">Réseau actuel :</span> {{ line.network | uppercase }}</div>
    <br/>
    <div>
        Vous pouvez passer sur le réseau
        <strong>{{ line.network.toLowerCase() == 'orange' ? 'SFR' : 'Orange' }}</strong> pour votre ligne <span
            class="bold-text"> {{ line.phoneNumber }} </span>, tout en conservant votre forfait actuel
        <strong>{{ line.offer.labelTunnel }}</strong>.
        @if (priceDetails == null || priceDetails?.price.toLowerCase() == 'gratuite') {
            <div>
                Une nouvelle carte SIM SFR va vous être envoyée gratuitement. Elle s'activera à la date que vous aurez
                choisie ci-dessous.
            </div>
        }
        @if (priceDetails != null && priceDetails?.price.toLowerCase() != 'gratuite') {
            <div>
                Vous recevrez une nouvelle carte SIM, qui sera
                facturée {{ priceDetails?.price }}@if (priceDetails?.perMonth) {
                <span>/mois</span>
            }. Elle s'activera à la date que vous aurez choisie ci-dessous.
            </div>
        }
    </div>
    <br/>
    <div class="bold-text mb-3">Date du changement de réseau* :
        <mat-form-field>
            <input matInput (dateChange)="setSelectedDate($event.value)" [formControl]="startDate"
                   [matDatepicker]="picker" [matDatepickerFilter]="portabilityDateFilter">
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon id="calendar-icon" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        @if (this.displayError) {
            <small class="form-text error-message">Ce champ est invalide.</small>
        }
    </div>
    Votre carte SIM sera livrée à l'adresse suivante :<br/><br/>
    <div class="col-12 text-center mb-3">
        <div class="d-flex justify-content-center">
            @if (shippingAddress) {
                <app-address-card [shippingAddress]="shippingAddress" [displayButton]="false"></app-address-card>
            }
        </div>
    </div>
    Pour modifier ou compléter votre adresse, <a routerLink="/compte/adresses/modifier/adresse-livraison">cliquez
    ici.</a> Une fois que vous l'aurez mise à jour, vous pourrez relancer la procédure de changement de réseau.
    <br><br>
    Si cette adresse est exacte, cliquez sur "Valider" pour confirmer votre demande de changement de réseau.
</div>

<div class="row w-100 pt-3 text-center">
    <div class="col-12 w-100 cta_container">
        <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
        <button type="button" class="cta_btn level_2 column" (click)="confirmation()">Valider<span></span></button>
    </div>
</div>
